import React from 'react'
import styles from './subscription.module.css'
import Text from '../text/Text'
import MenImagen from '../../assets/images/subscription/men.png'
import WomanImagen from '../../assets/images/subscription/woman.png'
import WomanElementImagen from '../../assets/images/subscription/woman-element.png'

interface SubscriptionProperties {
    image: 'men' | 'woman'
    name: string
    date: string
    commerceName: string
    data?: any
    onClick?: (data: any) => void
    element?: JSX.Element
}

export function Subscription(properties: SubscriptionProperties) {
    return (
        <div
            className={styles.container}
            onClick={() =>
                properties.onClick && properties.onClick(properties.data)
            }
        >
            <div
                className={styles.imageContent}
                style={{
                    backgroundImage: `url(${
                        properties.element
                            ? WomanElementImagen
                            : properties.image === 'men'
                            ? MenImagen
                            : WomanImagen
                    })`,
                }}
            >
                <div className={styles.topContent}>
                    <Text
                        label={properties.name}
                        fontFamily="Chewy"
                        fontWeight={400}
                        fontSize={properties.element ? 20 : 36}
                        color="#fff"
                    />
                    {properties.element}
                </div>
                <div>
                    <Text
                        label="Próximo cobro:"
                        lineHeight={0.6}
                        fontWeight={400}
                        fontSize={14}
                        color="#fff"
                    />
                    <Text
                        label={properties.date}
                        fontWeight={600}
                        fontSize={14}
                        color="#fff"
                    />
                </div>
            </div>
            <div className={styles.textContent}>
                <Text
                    label="Comercio:"
                    fontWeight={400}
                    color="#0086D6"
                    fontSize={16}
                />
                <Text
                    label="Cafeteria Juanita"
                    fontWeight={700}
                    color="#0086D6"
                    fontSize={16}
                />
            </div>
        </div>
    )
}
